import { makeStyles } from '@material-ui/core/styles';

const screenWidth = window.innerWidth

const dcsModalStyles = makeStyles((theme, isMobile) => (
  {
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 165,
  },
  closeFlightPaper: {
    position: 'absolute',
    top: '35%',
    width: screenWidth < 900 ? '80%' : '40%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
  },
  closeFlightSendingPaper: {
    position: 'absolute',
    top: '35%',
    width: '12%',
    height: '10%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: '2px 4px 2px 4px'
  },
  modalHeader: {
    fontSize: '40px',
    height: '20%',
    borderBottom: '2px solid rgba(201, 195, 195, 1)',
    backgroundColor: 'rgb(63, 81, 181, 1)'
  },
  editRow: {
    paddingTop: '8px',
    paddingBottom: '8px',
    backgroundColor: '#ede8e8'
  },
  // NOTE // combined editPax/movePax/textHist paper. (was 90:50 / 80:50 / 90:40 for width in the same order)
  paper: {
    position: 'absolute',
    width: screenWidth < 900 ? '90%' : '50%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
  },
  editPaxSendingPaper: {
    position: 'absolute',
    width: screenWidth < 900 ? '60%' : '15%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    marginTop: '12%',
    padding: '2px 4px 2px 4px'
  },
  sendTextStatusPaper: {
    position: 'absolute',
    width: screenWidth < 900 ? '70%' : '20%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    marginTop: '45vh',
    padding: '2px 4px 2px 4px'
  },
  accordionButton: {
    width: '100%',
    border: '1px solid black',
    backgroundColor: '#bbbbbb',
    cursor: 'pointer',
    position: 'relative'
  },
  instructionText: {
    fontWeight: 'bold',
    borderRadius: '15px',
    backgroundColor: '#cee7fd',
    paddingLeft: '3px',
    paddingRight: '3px',
    marginBottom: '8px'
  },
  arrowIcons: {
    position: 'absolute',
    top: '23%',
    left: '93%'
  },
  paperBasic: {
    position: 'absolute',
    width: screenWidth < 900 ? '80%' : '800px',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  bg0: {
    backgroundColor: 'gainsboro'
  },
  bg1: {
    backgroundColor: 'white'
  },
  center: {
    justifyContent: 'center',
    display: 'flex'
  },
  // TODO // change these to inline or more specific names
  header: {
    fontWeight: 'bold'
  },
  padding: {
    paddingLeft: '5px'
  },
  outboundPadding: {
    paddingRight: '5%'
  },
  inboundPadding: {
    paddingLeft: '5%'
  },
  outbound: {
    backgroundColor: '#005fff',
    color: 'white',
    marginTop: '10px',
    marginBottom: '10px',
    borderRadius: '25px',
    paddingLeft: '10px',
    paddingRight: '10px'
  },
  inbound: {
    backgroundColor: '#e3e3e3',
    marginTop: '10px',
    marginBottom: '10px',
    borderRadius: '25px',
    paddingLeft: '10px',
    paddingRight: '10px'

  },
  outboundMessageTimes: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingRight: '10px'
  },
  inboundMessageTimes: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingLeft: '10px'
  },
  centerDates: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end'
  },
  messageContainer: {
    maxHeight: '50vh',
    overflow: 'auto'
  },
  absoluteCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  textHistTextField: {
    margin: '12px 12px',
    border: 'black solid 1px'
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  movePaxButton: {
    height: '80%'
  }
}));

export default dcsModalStyles